import env from '../env';
import { Params as GetPolicyParams } from '../hooks/queries/usePolicyQuery';
import { POLICY_ID_MAP } from '../types/hubEnums';
import { sendGetRequest } from './RequestService';

class PolicyService {
  static async getPolicy({ country, policyType }: GetPolicyParams) {
    const lowerCaseCountry = country.toLowerCase();
    const url = `https://${env.REACT_APP_CLUEY_API_HOST_NAME}/customer-hub/policies/${lowerCaseCountry}/${POLICY_ID_MAP[policyType]}`;

    try {
      const res = await sendGetRequest({
        payload: {},
        url,
      });
      return res.json();
    } catch (error) {
      throw error;
    }
  }
}

export default PolicyService;
